export const environment = {
  production: true,
  url: '../.netlify/functions/hello',
  contactCtaMailUrl: '../.netlify/functions/contact-cta-mail',
  marketValuationUrl: '../.netlify/functions/market-valuation',
  withdrawalUrl: '../.netlify/functions/widerruf',
  // Cloudflare-Turnstile Site-Key (öffentlich, gehört ins Bundle).
  // Leer = Captcha-Widget wird nicht gerendert, Formular funktioniert weiterhin.
  TURNSTILE_SITE_KEY: '',
  SITE_URL: 'https://rwm-immobilien.de',
  CONTENTFUL_SPACE: 'vjmccdv0h9py',
  CONTENTFUL_ACCESS_TOKEN: 'CqVD9Wt_pokhGC8cgYJdIwtJpWBA6Mvf5Oc4ytwhofQ',
  CONTENTFUL_ENVIRONMENT: 'master',
  i18n: {
    defaultLang: 'de-DE',
    availableLangs: ['en', 'de']
  }
};
